import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  frenchDipUSEndDate,
  frenchDipUSStartDate,
  thanksgivingSubUSEndDate,
  thanksgivingSubUSStartDate,
  tripleStackUSEndDate,
  tripleStackUSStartDate,
} from '../constants';

export type LtoContentUSProps = {
  default?: ReactNode;
  tripleStack: ReactNode;
  thanksgivingSub: ReactNode;
  frenchDip: ReactNode;
};

export const LtoContentUS = ({
  tripleStack,
  default: defaultContent,
  thanksgivingSub,
  frenchDip,
}: LtoContentUSProps) => {
  return (
    <DatetimeShow
      after={frenchDipUSStartDate}
      before={frenchDipUSEndDate}
      default={
        <DatetimeShow
          after={thanksgivingSubUSStartDate}
          before={thanksgivingSubUSEndDate}
          default={
            <DatetimeShow
              after={tripleStackUSStartDate}
              before={tripleStackUSEndDate}
              default={defaultContent}
            >
              {tripleStack}
            </DatetimeShow>
          }
        >
          {thanksgivingSub}
        </DatetimeShow>
      }
    >
      {frenchDip}
    </DatetimeShow>
  );
};
